import React from "react";

import * as I from "immutable";
import moment from "moment-timezone";

import {MIN_SEARCH_LENGTH, ROUTE_UNASSIGNED_LABEL} from "config/constants";
import {apiDestination} from "v2/api/Destinations";
import {Route} from "v2/api/Records";
import {apiUser} from "v2/api/Users";
import {getRouteLabel} from "utils";

export const apiRoute = (route) => {
  return new Route({
    ...route,
    assignments: I.List(route.assignmentsData.map(apiUser)),
    date: moment(route.date),
    delay: route.delay && moment.duration(route.delay, "minutes"),
    destinations: I.List((route.destinationsData || []).map(apiDestination)),
    overlappedDestinations: I.List((route.overlappedDestinations || [])),
    type: route.kind,
  });
};

export const canReorderDestinations = (route) => {
  return route.destinations && route.destinations.size > 1 && !route.readOnly;
};

export const filterRoutesByGardenerOrType = (routes, search, serviceType) => {
  if (!search || search.length < MIN_SEARCH_LENGTH) {
    return routes;
  }

  const isServiceTypeMatched = (type, search) => {
    const found = serviceType.findEntry((value, key) => key === type);

    if (found) {
      const [foundType, foundTitle] = found;
      return foundType.toLowerCase().indexOf(search) === 0 ||
        foundTitle.toLowerCase().indexOf(search) === 0;
    }

    return false;
  };

  search = search.toLowerCase();
  const searchMatchUnassignedLabel = ROUTE_UNASSIGNED_LABEL
    .toLowerCase()
    .indexOf(search) !== -1;

  return routes.filter(({assignments, type}) => {
    const matchAssignee = assignments.isEmpty() ?
      searchMatchUnassignedLabel :
      assignments
        .find(({email, fullName}) => {
          return email.toLowerCase().indexOf(search) !== -1 ||
            fullName.toLowerCase().indexOf(search) !== -1;
        });
    return matchAssignee || isServiceTypeMatched(type, search);
  });
};

export const getRoutesOptions = (routes) => {
  if (!routes) return [];
  return routes
    .map(item => {
      const prefix = item.week.replace("Week ", "");
      return {
        htmlLabel: (
          <span>
            <strong>{prefix}:</strong> {getRouteLabel(item)}
          </span>
        ),
        label: getRouteLabel(item, true).join(""),
        value: item.id,
      };
    })
    .toArray();
};

export default {
  apiRoute,
  canReorderDestinations,
  filterRoutesByGardenerOrType,
  getRoutesOptions,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Routes.js
 **/